import { paletteBase } from '@abg/kit-base';
import { spacing } from '@abg/kit-base/lib/shared/constants';

export const vehicleImageContainerStyles = {
  position: 'relative',
  display: 'inline-block',
  '&:focus': {
    outline: 'none',
  },
};

export const circlePlusButtonStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export const accountTodayRentalContainerStyles = {
  padding: `${spacing.xs} ${spacing['2xs']}`,
  backgroundColor: paletteBase.lightGrey100,
  borderRadius: 2,
};
